import React from 'react';
import styled from 'styled-components';

import CountUp from 'react-countup';

import { Grid, Typography } from '@material-ui/core/';

const Root = styled(Grid)`
	padding: 0 20px;

	h6 {
		margin-top: 20px;
		font-size: 20px;
		font-weight: bold;
		text-transform: uppercase;
	}

	.counter {
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		text-align: center;
		transform: translateY(-50%);

		& > span {
			font-size: 48px;
			font-weight: bold;
			color: ${(props) => props.theme.palette.text.primary};
			background-image: ${(props) => props.theme.palette.text.gradient};
			background-clip: text;
			-webkit-background-clip: text;
			-moz-background-clip: text;
			-moz-text-fill-color: transparent;
			-webkit-text-fill-color: transparent;
		}
	}
`;

const ContentPerformance = ({ counterNumber = 0.76 }) => (
	<Root>
		<Typography variant="h6">Auswertung des Lastgangs</Typography>
		<Typography>
			Mit einem Batteriespeicher reduzieren wir ihre Lastspitze um:
		</Typography>
		<Typography className="counter">
			<CountUp
				start={0}
				end={counterNumber}
				duration={2.75}
				separator="."
				decimals={2}
				decimal=","
				suffix=" <span>kW</span>"
			/>
		</Typography>
	</Root>
);

export default ContentPerformance;
